module.exports = __webpack_public_path__ + "static/media/raffael.48b72575.png";